var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduce-main"},[_c('banner'),_c('feature'),_c('About'),_c('Services'),_c('Product'),_c('Customers'),_c('Teammate'),_c('Slide'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }